import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCopy, faPlay } from '@fortawesome/free-solid-svg-icons';
import {
  Icon,
  UilFilesLandscapesAlt,
  UilBook,
  UilUserSquare,
  UilSuitcase
} from '@iconscout/react-unicons';
import { UserType } from 'reducers/UserReducer';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  next?: boolean;
  accessEntity?: string;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export interface LogicRoute {
  path: string;
  label: string;
  icon?: IconProp;
}

const routesMap: { [key in UserType]: RouteItems[] } = {
  admin: [],
  candidate: [
    {
      label: 'Control Center',
      icon: UilFilesLandscapesAlt,
      pages: [
        {
          name: 'Home',
          icon: 'home',
          path: '/home/dashboard',
          pathName: 'home',
          active: true
        }
      ]
    },
    {
      label: 'Career Pathways',
      icon: UilSuitcase,
      pages: [
        {
          name: 'talent-ladder',
          icon: 'star',
          active: true,
          hasNew: true,
          pages: [
            {
              name: 'Basics',
              // icon: 'help-circle',
              path: '/home/ladder/basic',
              pathName: 'basic',
              active: true
            },
            {
              name: 'Logic',
              // icon: 'crosshair',
              path: '/home/ladder/logic',
              pathName: 'logic',
              active: false
            },
            {
              name: 'Personality',
              // icon: 'thumbs-up',
              path: '/home/ladder/personality',
              pathName: 'personality',
              active: false
            }
          ]
        },
        {
          name: 'Jobs',
          icon: 'briefcase',
          path: '/home/jobs',
          pathName: 'jobs',
          active: true
        }
      ]
    },
    {
      label: 'Account',
      icon: UilUserSquare,
      pages: [
        {
          name: 'Profile',
          icon: 'user',
          path: '/home/profile',
          pathName: 'profile',
          active: true
        }
      ]
    }
  ],
  institution: [
    {
      label: 'Control Center',
      icon: UilFilesLandscapesAlt,
      pages: [
        {
          name: 'Dashboard',
          icon: 'pie-chart',
          path: '/hub/dashboard',
          pathName: 'dashboard',
          active: true
        }
      ]
    },
    {
      label: 'Academy',
      icon: UilBook,
      pages: [
        {
          name: 'Students',
          icon: 'users',
          path: '/hub/students',
          pathName: 'students',
          active: true,
          accessEntity: 'student'
        }
      ]
    },
    {
      label: 'Account',
      icon: UilUserSquare,
      pages: [
        {
          name: 'Users',
          icon: 'users',
          path: '/hub/users',
          pathName: 'users',
          active: true,
          accessEntity: 'user'
        },
        {
          name: 'Profile',
          icon: 'user',
          path: '/hub/profile',
          pathName: 'profile',
          active: true,
          accessEntity: 'profile'
        }
      ]
    }
  ],
  recruiter: [
    {
      label: 'Control Center',
      icon: UilFilesLandscapesAlt,
      pages: [
        {
          name: 'Dashboard',
          icon: 'pie-chart',
          path: '/panel/dashboard',
          pathName: 'dashboard',
          active: true
        }
      ]
    },
    {
      label: 'Recruitment',
      icon: UilBook,
      pages: [
        {
          name: 'Search',
          icon: 'search',
          path: '/panel/recruitment/search',
          pathName: 'students',
          active: true
        },
        {
          name: 'Jobs / Internships',
          icon: 'briefcase',
          path: '/panel/recruitment/careers',
          pathName: 'students',
          active: true
        }
        // {
        //   name: 'Interviews',
        //   icon: 'tablet',
        //   path: '/panel/recruitment/interviews',
        //   pathName: 'students',
        //   active: true
        // }
      ]
    },
    {
      label: 'Account',
      icon: UilUserSquare,
      pages: [
        {
          name: 'Profile',
          icon: 'user',
          path: '/panel/profile',
          pathName: 'profile',
          active: true
        }
      ]
    }
  ]
};

// export const routes: RouteItems[] = [
//   {
//     label: 'Control Center',
//     icon: UilFilesLandscapesAlt,
//     pages: [
//       {
//         name: 'Dashboard',
//         icon: 'pie-chart',
//         path: '/dashboard',
//         pathName: 'dashboard',
//         active: true
//       }
//     ]
//   }
// ];

export function useRoute(userType?: UserType): RouteItems[] {
  return userType ? routesMap[userType] : [];
}

export function useLogicChallengeRoute(): LogicRoute[] {
  return [
    {
      label: 'Explorer',
      path: '/assessment/challenge/logic/explorer',
      icon: faCopy
    },
    {
      label: 'Run and Debug',
      path: '/assessment/challenge/logic/run',
      icon: faPlay
    }
  ];
}
